import { createContext } from "react";

export const DarkModeContext = createContext(false);
